<template>
  <div class="d-flex align-end align-md-center item">
    <v-container class="position-relative">
      <v-row justify="center" justify-md="end">
        <v-col class="pb-12 pb-md-0" cols="auto" md="6">
          <div
            class="
              white--text
              text-h6 text-md-h5 text-center text-md-left
              font-weight-medium
            "
          >
            {{ title }}
          </div>
          <div
            class="
              white--text
              text-h4 text-md-h3 text-center text-md-left
              font-weight-bold
              mt-3
            "
          >
            {{ subtitle }}
          </div>

          <ButtonWidget
            class="mt-6 mt-md-8"
            :align="smAndDown ? 'center' : 'left'"
            color="secondary"
            text-color="white"
            :to="path"
          >
            Cadastre seu currículo
          </ButtonWidget>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ButtonWidget from "../widgets/ButtonWidget.vue";

const _data = {
  title: "Faça parte da nossa equipe",
  subtitle: "Trabalhe Conosco",
  path: "/trabalhe-conosco",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  components: {
    ButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.item::v-deep {
  height: 540px;
  position: relative;

  &:before {
    bottom: 0;
    background-image: url(../../assets/img/trabalhe-conosco.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: right center;
    content: "";
    left: 0;
    position: absolute;
    right: 45%;
    top: 0;

    @media screen and (max-width: 959.9px) {
      bottom: 45%;
      right: 0;
    }
  }

  &:after {
    background: rgb(40, 40, 40);
    background: -moz-linear-gradient(
      90deg,
      rgba(40, 40, 40, 0) 0%,
      rgba(44, 76, 155, 1) 55%
    );
    background: -webkit-linear-gradient(
      90deg,
      rgba(40, 40, 40, 0) 0%,
      rgba(44, 76, 155, 1) 55%
    );
    background: linear-gradient(
      90deg,
      rgba(40, 40, 40, 0) 0%,
      rgba(44, 76, 155, 1) 55%
    );
    bottom: 0;
    content: "";
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#282828",endColorstr="#2c4c9b",GradientType=1);
    left: 0;
    position: absolute;
    right: 0;
    top: 0;

    @media screen and (max-width: 959.9px) {
      background: rgb(40, 40, 40);
      background: -moz-linear-gradient(
        180deg,
        rgba(40, 40, 40, 0) 0%,
        rgba(44, 76, 155, 1) 55%
      );
      background: -webkit-linear-gradient(
        180deg,
        rgba(40, 40, 40, 0) 0%,
        rgba(44, 76, 155, 1) 55%
      );
      background: linear-gradient(
        180deg,
        rgba(40, 40, 40, 0) 0%,
        rgba(44, 76, 155, 1) 55%
      );
      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#282828",endColorstr="#2c4c9b",GradientType=1);
    }
  }

  .container {
    z-index: 2;
  }
}
</style>
